export function setLoggedIn(state, value) {
  state.loggedIn = value;
}
